// extracted by mini-css-extract-plugin
export default {"cls1":"CreateComment-cls1__fz","cls2":"CreateComment-cls2_OBh CreateComment-cls1__fz"};